import {
  WorkLogsApiListWorkLogsRequest,
  WorkLogStatus
} from "@wingspanhq/wingspan-api-sdk";
import { Filter, WorkLogPayeeTabFilterStatus } from "./types";

const PAYEE_STATUS_MAP: Record<WorkLogPayeeTabFilterStatus, WorkLogStatus[]> = {
  // In-progress tab shows both Draft and InProgress work logs for payee view
  [WorkLogPayeeTabFilterStatus.InProgress]: [
    WorkLogStatus.DRAFT,
    WorkLogStatus.IN_PROGRESS
  ],
  [WorkLogPayeeTabFilterStatus.Submitted]: [WorkLogStatus.IN_REVIEW],
  [WorkLogPayeeTabFilterStatus.Approved]: [WorkLogStatus.APPROVED],
  [WorkLogPayeeTabFilterStatus.Rejected]: [WorkLogStatus.REJECTED]
};

export function createListRequest(
  accountId: string,
  filter?: Filter
): WorkLogsApiListWorkLogsRequest {
  const request: WorkLogsApiListWorkLogsRequest = {
    filter: {
      // Account scope mapped to `payeeAccountId.eq` from the v3 session accountId.
      payeeAccountId: { eq: accountId }
    }
  };

  if (filter?.assignmentId) {
    request.filter!.payeeEngagementId = { eq: filter.assignmentId };
  }

  if (filter?.status) {
    request.filter!.status = { anyOf: PAYEE_STATUS_MAP[filter.status] };
  }

  return request;
}
